<template>
  <div class="guide-step text-center">
    <div class="guide-step__tabs py-30 px-15">
      <div class="tile is-ancestor">
        <div v-for="step in steps" :key="step.id" class="tile is-parent">
          <article class="tile is-child">
            <a :href="`#${step.name}`" class="recommend_content_what">{{ step.text }}</a>
          </article>
        </div>
      </div>
    </div>
    <div id="guide-procedures" class="guide-step__content pt-70 pb-35 mb-35">
      <h5 class="recommend-guide__title c-text-primary">おすすめの手順</h5>
      <div v-for="procedure in procedures" :key="procedure.id" class="tile mb-40 is-ancestor">
        <div class="tile is-parent is-9 align-items-center">
          <div class="recommend-step">
            <img :src="procedure.img_l" class="recommend_step_img_l" />
          </div>
          <div class="recommend-step">
            <div class="d-flex align-items-center">
              <div class="recommend-step__number fs-48 f-style-i c-text-primary">
                {{ procedure.id }}
              </div>
              <div class="recommend-step__text" v-html="procedure.text"></div>
            </div>
          </div>
        </div>

        <div class="tile is-parent is-3">
          <div class="tile is-child recommend-step">
            <div v-if="procedure.img_ss_r && procedure.img_ss_r.length >= 2">
              <img :src="procedure.img_ss_r[0]" class="recommend_step_social_sharing" />
              <img :src="procedure.img_ss_r[1]" class="recommend_step_social_sharing" />
            </div>
            <img v-else :src="procedure.img_r" class="recommend_step_img_r" />
          </div>
        </div>
      </div>
    </div>
    <div id="guide-tokens" class="guide-step__content pt-35 mt-35 pb-35 mb-35">
      <h5 class="recommend-guide__title text-center c-text-primary">トークンはどうやって使えますか？</h5>
      <div class="text-center fs-14 text-bold">
        Reptopでの商品の購入代金やトランザクションフィーなどに
        <br />
        使用することができます。
      </div>
    </div>
    <div id="guide-quality" class="guide-step__content pt-35 mt-35 pb-35">
      <h5 class="recommend-guide__title text-center c-text-primary">
        トークン目当てで質の低いおすすめが増えませんか？
      </h5>
      <div class="text-center fs-14 text-bold">
        おすすめできる商品の数には制限があります。<br /><br />

        おすすめから購入したユーザーのレビューでGoodが付くと<br />
        評価ポイントがプラスされ、一定ポイントが貯まるとおすすめできる商品の数が増えます。<br /><br />

        逆におすすめから購入したユーザーのレビューでBadが付くと<br />
        評価ポイントがマイナスされ、おすすめできる商品の数が減ります。<br /><br />

        質の高い商品をおすすめをするユーザーはより多くのおすすめができるのに対し、
      </div>
      <div class="text-center fs-14 c-text-primary text-bold">
        質の低い商品をおすすめをするユーザーは<br />
        おすすめ商品を追加できなくなっていく仕組みになっています。<br />
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="../recommend.scss">
</style>

<script>
export default {
  name: 'RecommendSteps',
  components: {},
  data() {
    return {
      steps: [
        {
          id: 1,
          name: 'guide-procedures',
          text: 'おすすめの手順'
        },
        {
          id: 2,
          name: 'guide-tokens',
          text: 'トークンはどうやって使えますか？'
        },
        {
          id: 3,
          name: 'guide-quality',
          text: 'トークン目当てで質の低いおすすめが増えませんか？'
        }
      ],
      procedures: [
        {
          id: 1,
          text: '気に入った商品のページで<br>おすすめに追加ボタンを選択します。',
          img_l: require('@/assets/images/recommend/guide/how-to-flow-l-01.svg'),
          img_r: require('@/assets/images/recommend/guide/how-to-flow-r-01.svg')
        },
        {
          id: 2,
          text: 'シェアボタンからSNSで<br>おすすめ商品の紹介を投稿します。',
          img_l: require('@/assets/images/recommend/guide/how-to-flow-l-02.svg'),
          img_ss_r: [
            require('@/assets/images/icons/icon-twitter.svg'),
            require('@/assets/images/icons/icon-facebook.svg')
          ]
        },
        {
          id: 3,
          text: 'あなたの投稿から購入されると<br>トークンを受け取れます！',
          img_l: require('@/assets/images/recommend/guide/how-to-flow-l-03.svg'),
          img_r: require('@/assets/images/recommend/guide/how-to-flow-r-03.svg')
        }
      ]
    };
  },
  async mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {}
  }
};
</script>
